export default import.meta.ROLLDOWN_FILE_URL_4YUY9nxvQVjPEr5wcQK7mg